// extracted by mini-css-extract-plugin
export default {"download-sales-receipt":"styles_download-sales-receipt__+1gVX"};